<template>
  <div class="exports">
    <div class="my-5 d-flex align-center justify-space-between">
      <header>
        <h1 class="display-2">
          {{ $t("Exports") }}
        </h1>
      </header>
      <div class="d-flex align-center">
        <exports-forms-search class="ma-2" />
      </div>
    </div>
    <exports-data-table class="flex-grow-1 d-flex flex-column" />
    <div class="env" :class="env">
      <div>{{ env }}</div>
    </div>
    <v-navigation-drawer
      class="create-button-drawer"
      v-model="isExportDrawerOpen"
      :width="512"
      fixed
      temporary
      right
    >
      <v-progress-linear v-if="false" absolute indeterminate />
    </v-navigation-drawer>
  </div>
</template>

<script>
import ExportsDataTable from "@/components/exports/DataTable.vue";
import ExportsFormsSearch from "@/components/exports/forms/Search.vue";

import { mapAppFields } from "@/store/modules/app";

export default {
  data() {
    return {
      env: process.env.VUE_APP_API_ENV
    };
  },
  name: "exports",
  components: {
    ExportsDataTable,
    ExportsFormsSearch
  },
  computed: {
    ...mapAppFields(["isExportDrawerOpen"])
  }
};
</script>

<style lang="scss">
.exports {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.env {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgb(255, 255, 255);
  height: 96px;
  width: 96px;
  border-radius: 50%;

  position: absolute;
  left: 8px;
  bottom: 8px;
}

.LOCAL {
  background-color: #1ab5a9;
  opacity: 0.8;
}
.DEV,
.RCT {
  background-color: #4955bb;
  opacity: 0.8;
}
.PROD {
  background-color: rgb(255, 255, 255);
  visibility: hidden;
}
</style>
